const isInvoiceDiagnosticsEnabled =
  process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENABLE_INVOICE_LOGGER === 'true';

export const invoiceLogger = {
  debug: (...args: unknown[]) => {
    if (isInvoiceDiagnosticsEnabled) {
      console.log(...args);
    }
  },
  warn: (...args: unknown[]) => {
    if (isInvoiceDiagnosticsEnabled) {
      console.warn(...args);
    }
  },
  error: (...args: unknown[]) => {
    if (isInvoiceDiagnosticsEnabled) {
      console.error(...args);
    }
  },
};
